<template>
  <v-container class="user-report">
    <h2 class="mt-5 mb-10">{{$t('user_report')}}</h2>
    <v-card class="px-3 my-3">
      <v-row>
        <!-- <v-col md="3"><v-text-field v-model="start_date"></v-text-field></v-col>
        <v-col md="3"><v-text-field v-model="end_date"></v-text-field></v-col> -->
        <v-col md="3" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu_start"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted(start_date)"
                :label="$t('start_date')"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="start_date"
              @change="onStartDateChange"
              no-title
              scrollable
              :locale="$t('locale')"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu_end"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted(end_date)"
                :label="$t('end_date')"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="end_date"
              @change="onEndDateChange"
              no-title
              scrollable
              :min="start_date"
              :locale="$t('locale')"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3">
          <v-autocomplete
            :label="$t('find_group')"
            :items="groupList"
            v-model="group"
            item-text="alias"
            item-value="id"
            :rules="[validator.alfaNumberNotRequired]"
          ></v-autocomplete>
        </v-col>
        <v-col md="3">
          <!-- <v-select
            prepend-icon="mdi-account"
            :items="userList"
            label="Select User"
            v-model="id"
            item-text="full_name"
            item-value="id"
            v-on:change="onSelectUser"
          ></v-select> -->
          <v-autocomplete
            :label="$t('find_a_user')"
            :items="userList"
            v-model="id"
            item-text="full_name"
            item-value="id"
            :rules="[validator.alfaNumberNotRequired]"
          ></v-autocomplete>
        </v-col>
        <v-col md="3" offset="9" class="pa-6">
          <!-- <v-btn block outlined color="primary" :disabled="checkFileExists">
            <v-icon>mdi-download</v-icon>
            <download-excel
              :data="newdata"
              worksheet="User Summary"
              :name="file_name"
            >
              Download Report
            </download-excel>
          </v-btn> -->
            <v-btn block color="primary" @click="onSelectUser"
              ><v-icon>mdi-magnify</v-icon>{{$t('search')}}</v-btn
            >
        </v-col>
      </v-row>
    </v-card>
    <!-- <v-card class="px-3 my-3"> -->
    <v-row>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 error--text">{{
                userStatistics.totaldeductionhour
              }}</v-list-item-title>
              <v-list-item-subtitle>{{$t('total_late')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 error--text">Rp {{
                userStatistics.totaldeductionnominal
              }}</v-list-item-title>
              <v-list-item-subtitle>{{$t('total_deduction')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 success--text">{{
                userStatistics.totalworkhour
              }}</v-list-item-title>
              <v-list-item-subtitle>{{$t('total_working_hour')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 success--text">Rp {{
                userStatistics.payroll
              }}</v-list-item-title>
              <v-list-item-subtitle>{{$t('total_payroll')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-card> -->
    <v-card class="mt-4">
      <v-row>
        <v-col md="9">
          <v-card-title>
            {{$t('user_report')}}
          </v-card-title>
          <v-card-subtitle>
            {{$t('employeeCode')}}: {{ userStatistics.employeecode }}
          </v-card-subtitle>
        </v-col>
        <v-col md="3" class="pa-7">
          <download-excel
            :data="newdata"
            :worksheet="$t('user_summary')"
            :name="file_name"
          >
            <v-btn block outlined color="primary" :disabled="checkFileExists">
              <v-icon>mdi-download</v-icon>
              {{$t('download_report')}}
            </v-btn>
          </download-excel>
        </v-col>
      </v-row>
      <v-data-table
        :loading="loading"
        :loading-text="$t('loading_attendance')"
        :headers="headers"
        :items="summary"
        :sort-by="['time_out', 'time_in']"
        :sort-desc="[true, true]"
        multi-sort
        :no-data-text="$t('no_data')"
        :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
      >
        <template v-slot:item.time_in="{ item }">
          {{ milisToDate(item.time_in) }}
        </template>
        <template v-slot:item.time_out="{ item }">
          {{ milisToDate(item.time_out) }}
        </template>
         <template v-slot:item.reason_in="{ item }">
          <div
            v-if="checkReason(item.reason_in)"
          >{{ translateMe(item.reason_in) }}</div>
          <div v-else>-</div>
        </template>
         <template v-slot:item.reason_out="{ item }">
          <div
            v-if="checkReason(item.reason_out)"
          >{{ translateMe(item.reason_out) }}</div>
          <div v-else>-</div>
        </template>
         <template v-slot:item.note_in="{ item }">
          <div
            v-if="checkReason(item.note_in)"
          >{{ translateMe(item.note_in) }}</div>
          <div v-else>-</div>
        </template>
         <template v-slot:item.note_out="{ item }">
          <div
            v-if="checkReason(item.note_out)"
          >{{ translateMe(item.note_out) }}</div>
          <div v-else>-</div>
        </template>
        <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import _ from "lodash";
// import firebase from "firebase";
import numeral from "numeral";
import moment from "moment";
export default {
  name: "user-report",
  data() {
    return {
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      menu_start: false,
      menu_end: false,
      headers: [
        // { text: "Name", value: "username" },
        { text: this.$i18n.t('time_in'), value: "time_in" },
        { text: this.$i18n.t('time_out'), value: "time_out" },
        // { text: "Latitude", value: "lng_in" },
        // { text: "Longitude", value: "lng_out" },
        { text: this.$i18n.t('reason_in'), value: "reason_in" },
        { text: this.$i18n.t('reason_out'), value: "reason_out" },
        { text: this.$i18n.t('location_in'), value: "note_in" },
        { text: this.$i18n.t('location_out'), value: "note_out" },
        { text: this.$i18n.t('deduction'), value: "deduction" }
      ],
      userStatistics: {},
      userList: [],
      id: "",
      start_date: "",
      end_date: "",
      summary: [],
      file_name: "",
      loading: false,
      newdata: [],
      group: null,
      groupList: []
    };
  },
  computed: {
    checkFileExists() {
      if (this.file_name == "") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    checkReason(key) {
      switch (key) {
        case null:
        case '-':
        case '':
          return false
        default:
          return true
      }
    },
    getReasonColor(reason) {
      if (reason === "-" || reason === null || reason === 'Day Off') {
        return;
      }
      if (reason === "On-Time") {
        return "success";
      } else {
        if (reason === "In-Tolerance") {
          return "warning";
        }
        else if (reason === "Edited") {
          return "primary"
        }
         else {
          return "error";
        }
      }
    },
    translateMe(word){
      const translate = word.toLowerCase()
      return this.$i18n.t(translate)
    },
    async fetchGroupDetails() {
      const result = await this.$store.dispatch('getGroupByCompany', { companyId: this.$store.state.company })
      this.groupList = result
      this.groupList.unshift({ alias: this.$i18n.t('all'), id: null })
    },
    onStartDateChange() {
      const diff = moment(this.end_date).diff(this.start_date, 'days')
      if (diff < 0) this.end_date = this.start_date
      this.menu_start = false;
    },
    onEndDateChange() {
      this.menu_end = false;
    },
    dateFormatted(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
    },
    milisToDate(milis) {
      switch (moment(milis, "x").format("mm:ss:SS")) {
        case '00:00:00':
          return moment(milis, "x").format("DD-MM-YYYY --:--");
      
        default:
          return moment(milis, "x").format("DD-MM-YYYY HH:mm");
      }
    },
    milisToDateOnly(milis) {
      return moment(milis, "x").format("DD-MM-YYYY");
    },
    milisToHour(milis) {
      switch (moment(milis, "x").format("mm:ss:SS")) {
        case '00:00:00':
          return moment(milis, "x").format("--:--");
        default:
          return moment(milis, "x").format("HH:mm");
      }
    },
    toNumeral(number) {
      return numeral(number).format("0,0");
    },
    milisToTime(milis) {
      let d = moment.duration(milis, "milliseconds");
      let hours = Math.floor(d.asHours());
      let mins = Math.floor(d.asMinutes()) - hours * 60;
      return this.toNumeral(hours) + ` ${this.$i18n.t('hrs')} ` + mins + ` ${this.$i18n.t('min')}`;
    },
    onSelectUser() {
      this.loading = true;
      this.file_name = "";
      this.getUserStatistics(this.id);
    },
    async getUserStatistics(user_id) {
      let date_start = moment(this.start_date).format("DD-MM-YYYY");
      let date_end = moment(this.end_date).format("DD-MM-YYYY");
      const params = {
        userId: user_id,
        tglMulai: date_start,
        tglAkhir: date_end
      }
      if (this.group > 0) params.groupId = this.group
      this.loading = true
      const result = await this.$store.dispatch('getReportSummaryPerUserDashboard', params)
      this.loading = false;
      this.userStatistics = result;
      this.summary = this.userStatistics.summaries;
      this.newdata = []
      if (this.summary[0]) {
        this.summary.forEach((val, i) => {
          this.newdata.push({            
            [this.$i18n.t('employeeCode')]: this.summary[i].employeecode,
            [this.$i18n.t('full_name')]: this.summary[i].username,
            [this.$i18n.t('email')]: this.summary[i].email,
            [this.$i18n.t('date_in')]: this.milisToDateOnly(this.summary[i].time_in),
            [this.$i18n.t('time_in')]: this.milisToHour(this.summary[i].time_in),
            [this.$i18n.t('reason_in')]: this.summary[i].reason_in,
            [this.$i18n.t('reason_user_in')]: this.summary[i].reason_user_in,
            [this.$i18n.t('note_in')]: this.summary[i].note_in,
            [this.$i18n.t('note_user_in')]: this.summary[i].note_user_in,
            [this.$i18n.t('date_out')]: this.milisToDateOnly(this.summary[i].time_out),
            [this.$i18n.t('time_out')]: this.milisToHour(this.summary[i].time_out),
            [this.$i18n.t('reason_out')]: this.summary[i].reason_out,
            [this.$i18n.t('reason_user_out')]: this.summary[i].reason_user_out,
            [this.$i18n.t('note_out')]: this.summary[i].note_out,
            [this.$i18n.t('note_user_out')]: this.summary[i].note_user_out,
            [this.$i18n.t('status')]: this.summary[i].status,
            [this.$i18n.t('deduction')]: this.summary[i].deduction,
            [this.$i18n.t('workhour')]: this.milisToTime(this.summary[i].workhour),
            [this.$i18n.t('overtime')]: this.milisToTime(this.summary[i].overtime),
          });
        });
        this.file_name = this.summary[0].username + ` Summary (${date_start} - ${date_end}).xls`;
      } else {
        // eslint-disable-next-line no-console
        console.info("no data found"); // TODO: Change to notification
      }
    },
    async getUserList() {
      const companyId = this.$store.state.company;
      const result = await this.$store.dispatch('getEmployeeListNoPagination', { companyId })
      this.userList = [];
      result.rows.forEach(row => {
        if (row.role != 2) {
          this.userList.push(row);
        }
      });
      this.userList = _.orderBy(
        this.userList,
        [user => user.full_name ? user.full_name.toLowerCase() : ''],
        ["asc"]
      )
    }
  },
  created() {
    this.start_date = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.end_date = moment().format("YYYY-MM-DD");
    this.getUserList();
    this.fetchGroupDetails()
  }
};
</script>